__turbopack_context__.v({
  "cls1": "IlluHandshake-module__9KQKsq__cls1",
  "cls2": "IlluHandshake-module__9KQKsq__cls2",
  "cls3": "IlluHandshake-module__9KQKsq__cls3",
});
